import { render } from "./ProductOrdersHistoryModal.vue?vue&type=template&id=831339c2&scoped=true"
import script from "./ProductOrdersHistoryModal.vue?vue&type=script&lang=js"
export * from "./ProductOrdersHistoryModal.vue?vue&type=script&lang=js"

import "./ProductOrdersHistoryModal.vue?vue&type=style&index=0&id=831339c2&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831339c2"]])

export default __exports__